export const PRODUCTS = [
  {
    id: "prod-bopp-self-adhesive",
    name: "BOPP Self-Adhesive Bags",
    category: "BOPP Bags",
    description:
      "Crystal-clear biaxially oriented polypropylene bags with self-adhesive closure. Ideal for textile packaging, garment protection, and retail display.",
    specifications: {
      Material: "BOPP (Biaxially Oriented Polypropylene)",
      Thickness: "30-50 microns",
      Sizes: "Custom sizes available",
      Closure: "Self-adhesive strip",
      MOQ: "10,000 pieces",
    },
    image_url:
      "https://customer-assets.emergentagent.com/job_0a2bc895-7b15-4ac3-bad9-8999ca920027/artifacts/9gz9u6fa_WhatsApp%20Image%202026-04-12%20at%2012.48.02%20%282%29.jpeg",
    featured: true,
  },
  {
    id: "prod-bopp-printed",
    name: "BOPP Printed Bags",
    category: "BOPP Bags",
    description:
      "High-quality printed BOPP bags with vibrant color reproduction for branded packaging and product presentation.",
    specifications: {
      Material: "BOPP Film",
      Printing: "Up to 8 colors",
      Finish: "Matte / Glossy",
      Sizes: "Customizable",
      MOQ: "25,000 pieces",
    },
    image_url:
      "https://customer-assets.emergentagent.com/job_0a2bc895-7b15-4ac3-bad9-8999ca920027/artifacts/udrtetjh_WhatsApp%20Image%202026-04-12%20at%2012.48.02%20%281%29.jpeg",
    featured: true,
  },
  {
    id: "prod-poly-wrap",
    name: "Polyester Wrapping Plastic",
    category: "Polyester Sheets",
    description:
      "High-clarity polyester wrapping plastic designed for textile garment packaging with reliable protection during storage and shipping.",
    specifications: {
      Material: "PET Polyester Wrapping Film",
      Thickness: "18-70 microns",
      Finish: "Transparent / Glossy",
      "Print Compatibility": "Excellent",
      MOQ: "500 kg",
    },
    image_url: "/images/polyester-wrapping-plastic.jpeg",
    featured: true,
  },
  {
    id: "prod-poly-lam",
    name: "Polyester Lamination Film",
    category: "Polyester Sheets",
    description:
      "High-performance lamination grade polyester film with excellent moisture barrier, durability, and print surface.",
    specifications: {
      Material: "PET Lamination Grade",
      Thickness: "12-36 microns",
      "Corona Treated": "Yes",
      Transparency: "High clarity",
      MOQ: "500 kg",
    },
    image_url: "/images/polyester-lamination-film.jpeg",
    featured: false,
  },
  {
    id: "prod-ld-grade",
    name: "LD Grade Plastic Packaging",
    category: "Readymade Packaging",
    description:
      "LD-grade transparent plastic packaging for garments and textile products with clean presentation and moisture protection.",
    specifications: {
      Material: "LDPE (Low-Density Polyethylene)",
      Thickness: "40-90 microns",
      Sizes: "Customizable as per garment dimensions",
      Finish: "Transparent / Glossy",
      MOQ: "10,000 pieces",
    },
    image_url: "/images/ld-grade-plastic-packaging.jpeg",
    featured: true,
  },
  {
    id: "prod-textile-covers",
    name: "Textile Garment Covers",
    category: "Readymade Packaging",
    description:
      "Transparent garment covers designed specifically for textile packaging and transportation visibility.",
    specifications: {
      Material: "LDPE / BOPP",
      Types: "Flat, Gusseted, Perforated",
      Printing: "Optional",
      "Hanger Hole": "Available",
      MOQ: "5,000 pieces",
    },
    image_url: "/images/textile-garment-covers.jpeg",
    featured: false,
  },
];

export const GALLERY_ITEMS = [
  {
    id: "gal-factory-entrance",
    title: "JSY Factory Entrance",
    category: "Factory",
    image_url: "/images/about-factory-gate.png",
    description: "Front view of our JSY Printing facility at Maheshtala, Kolkata",
  },
  {
    id: "gal-factory-floor",
    title: "Factory Production Floor",
    category: "Factory",
    image_url: "/images/factory-floor-interior.jpeg",
    description: "Inside view of our active factory floor with packaging production operations",
  },
  {
    id: "gal-machine-pouch",
    title: "Automatic Pouch Making Machine",
    category: "Factory",
    image_url:
      "https://customer-assets.emergentagent.com/job_0a2bc895-7b15-4ac3-bad9-8999ca920027/artifacts/555eg9yz_WhatsApp%20Image%202026-04-12%20at%2012.48.01.jpeg",
    description: "High-speed pouch making setup for consistent output and clean sealing",
  },
  {
    id: "gal-machine-flexo",
    title: "Flexographic Printing Press",
    category: "Factory",
    image_url:
      "https://customer-assets.emergentagent.com/job_0a2bc895-7b15-4ac3-bad9-8999ca920027/artifacts/jyki826a_WhatsApp%20Image%202026-04-12%20at%2012.48.02.jpeg",
    description: "Multi-color flexographic press for high-quality print registration",
  },
  {
    id: "gal-machine-bottom-seal",
    title: "Automatic Bottom Sealing Machine",
    category: "Factory",
    image_url: "/images/machine-side-sealing.jpeg",
    description: "Reliable bottom and side sealing for readymade packaging production",
  },
  {
    id: "gal-machine-roto",
    title: "Rotogravure Printing Machine",
    category: "Factory",
    image_url: "/images/machine-roll-cutting.jpeg",
    description: "Industrial printing and finishing unit supporting precision packaging workflows",
  },
  {
    id: "gal-bopp-self",
    title: "BOPP Self-Adhesive Bags",
    category: "Products",
    image_url:
      "https://customer-assets.emergentagent.com/job_0a2bc895-7b15-4ac3-bad9-8999ca920027/artifacts/9gz9u6fa_WhatsApp%20Image%202026-04-12%20at%2012.48.02%20%282%29.jpeg",
    description: "Crystal-clear BOPP bags with self-adhesive closure",
  },
  {
    id: "gal-bopp-printed",
    title: "BOPP Printed Bags",
    category: "Products",
    image_url:
      "https://customer-assets.emergentagent.com/job_0a2bc895-7b15-4ac3-bad9-8999ca920027/artifacts/udrtetjh_WhatsApp%20Image%202026-04-12%20at%2012.48.02%20%281%29.jpeg",
    description: "Custom printed BOPP bags for branded textile packaging",
  },
  {
    id: "gal-ld-grade",
    title: "LD Grade Plastic Packaging",
    category: "Products",
    image_url: "/images/ld-grade-plastic-packaging.jpeg",
    description: "LD-grade transparent plastic packaging for garment applications",
  },
  {
    id: "gal-textile-covers",
    title: "Textile Garment Covers",
    category: "Products",
    image_url: "/images/textile-garment-covers.jpeg",
    description: "Readymade transparent garment covers for textile protection",
  },
  {
    id: "gal-poly-wrap",
    title: "Polyester Wrapping Plastic",
    category: "Products",
    image_url: "/images/polyester-wrapping-plastic.jpeg",
    description: "High-clarity polyester wrapping plastic for textile packaging",
  },
  {
    id: "gal-poly-lam",
    title: "Polyester Lamination Film",
    category: "Products",
    image_url: "/images/polyester-lamination-film.jpeg",
    description: "Lamination-grade polyester film with excellent clarity and protection",
  },
];